(function ($) {

  const initializeBlock = function ($block) {
    const $gridItems = $block.find(".grid--contentRow .contentRow-gridItem");

    var buttonWidest = 0

    $($gridItems).each(function(index, el) {
      var currentButtonWidth = $(this).find('.btn').outerWidth()

      if (currentButtonWidth > buttonWidest) {
        buttonWidest = currentButtonWidth
      }
    });

    $($gridItems).find('.btn').css('min-width', buttonWidest + 'px')
  }

  $(document).ready(function () {
    $('.block--column-content').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=column-content', initializeBlock);
  }

})(jQuery);